import React, { useState } from "react";
import { translate } from "../Services/translation";

const DealerEmailObfuscate = ({ email }) => {
  const [showHidden, setShowHidden] = useState(false);

  const obfuscated = email
    .split("")
    .map((char) => `&#${char.charCodeAt(0)};`)
    .join("");

  return (
    <div onClick={setShowHidden}>
      {showHidden ? (
        <a href={`mailto:${email}`} className="dealer__collapsible-content-obj">
          <i className="bi bi-envelope" />
          <span dangerouslySetInnerHTML={{ __html: obfuscated }} />
        </a>
      ) : (
        <div className="dealer__collapsible-content-obj email-button">
          <i className="bi bi-envelope" />
          <span>{translate("dealers.show-email")}</span>
        </div>
      )}
    </div>
  );
};

export default DealerEmailObfuscate;
